var map = {
	"./accents-en.json": [
		78,
		78
	],
	"./accents-es.json": [
		24,
		24
	],
	"./accents-no.json": [
		447,
		447
	],
	"./accents-pt.json": [
		334,
		334
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 682;
module.exports = webpackAsyncContext;